module.exports = __webpack_public_path__ + "static/media/rin_deactive0f58830a152175cb759c632840af6a5f.webp";